const getMarkerName = marker => {
  return marker.name;
};
export default getMarkerName;